(function () {
  const button = document.querySelector('[data-site-back-to-top]');
  if (!button) return;

  const SHOW_AFTER = 320;
  let ticking = false;

  const update = () => {
    ticking = false;
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    button.classList.toggle('is-visible', y > SHOW_AFTER);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  button.addEventListener('click', (event) => {
    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
